// extracted by mini-css-extract-plugin
export var addButton = "_od-0";
export var border = "_od-8";
export var check = "_od-h";
export var danger = "_od-6";
export var dropdownContainer = "_od-1";
export var editModalBody = "_od-j";
export var footerContainer = "_od-i";
export var fullWidth = "_od-a";
export var hide = "_od-9";
export var icon = "_od-3";
export var input = "_od-7";
export var inputFlex = "_od-b";
export var inputWrapper = "_od-c";
export var manualFocus = "_od-5";
export var optionButton = "_od-4";
export var pillWrapper = "_od-e";
export var pointer = "_od-2";
export var showOverflow = "_od-f";
export var tagsFlex = "_od-d";
export var xButton = "_od-g";